/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    MOBILE_TABLET_MIGRATION_PHASE8
 * Date:         2026-02-09
 * Modified By:  Claude
 *
 * Description:
 * Updated AppShell to handle mobile header padding and safe area insets.
 * Content area now has padding-top for mobile fixed header.
 *
 * Related Screens / Modules:
 * - client/src/components/layout/AppShell.tsx
 * - client/src/components/layout/Navbar.tsx
 */

import React from "react";
import Navbar from "./Navbar";
import { useMediaQuery } from "../../hooks/useMediaQuery";

type Props = { children: React.ReactNode };

// [2026-02-13] Maya: Tablet uses hamburger menu like mobile, so apply mobile shell layout
export default function AppShell({ children }: Props) {
  const { isMobile, isTablet } = useMediaQuery();

  return (
    <div className={`uz-shell ${isMobile || isTablet ? "uz-shell--mobile" : ""}`}>
      <Navbar />
      <main className="uz-shell__content">{children}</main>
    </div>
  );
}
